/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaLineupPositionPlayer = {
    properties: {
        fantaPlayerTeam: {
            type: 'FantaPlayerTeam',
            isRequired: true,
        },
        position: {
            type: 'LineupPosition',
            isRequired: true,
        },
        booster: {
            type: 'any-of',
            contains: [{
                type: 'FantaBooster',
            }, {
                type: 'null',
            }],
        },
        points: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
